import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import Amplify from '@aws-amplify/core';

fetch('/assets/amplify-config.json')
  .then(response => response.json())
  .then(config => Amplify.configure(config))
  .catch(error => console.error('Failed to load Amplify config:', error));

if (environment.production) enableProdMode();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));